import React, { useState } from 'react';
import { Fab, Box, Typography, Paper, Grow, ClickAwayListener } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import { Link } from "react-router-dom";

const options = [
    { icon: <ReceiptLongIcon sx={{ fontSize: '1.1rem' }} />, label: 'Upload Receipt', to: '/upload-receipt' },
    { icon: <DescriptionIcon sx={{ fontSize: '1.1rem' }} />, label: 'Upload Bank Statement', to: '/upload-findoc' },
];

export default function FloatingActionButtonZoom() {
    const [open, setOpen] = useState(false);

    return (
        <Box sx={{ position: 'fixed', right: 24, bottom: 24, zIndex: 1100 }}>
            {open && (
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <Grow in={open}>
                        <Paper sx={{
                            position: 'absolute', bottom: 64, right: 0, borderRadius: 3, overflow: 'hidden',
                            boxShadow: '0 12px 40px rgba(0,0,0,0.12)', border: '1px solid rgba(0,0,0,0.06)', minWidth: 220,
                        }}>
                            {options.map((opt, i) => (
                                <Box key={opt.label} component={Link} to={opt.to} onClick={() => setOpen(false)}
                                    sx={{
                                        display: 'flex', alignItems: 'center', gap: 1.5, px: 2.5, py: 1.5,
                                        textDecoration: 'none', color: 'text.primary',
                                        borderBottom: i < options.length - 1 ? '1px solid rgba(0,0,0,0.06)' : 'none',
                                        transition: 'background 0.15s',
                                        '&:hover': { background: 'rgba(99,102,241,0.06)' },
                                    }}>
                                    <Box sx={{ color: 'primary.main' }}>{opt.icon}</Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>{opt.label}</Typography>
                                </Box>
                            ))}
                        </Paper>
                    </Grow>
                </ClickAwayListener>
            )}
            <Fab color="primary" onClick={() => setOpen(!open)}
                sx={{
                    background: 'linear-gradient(135deg, #1F2F42 0%, #3A5068 100%)',
                    boxShadow: '0 8px 25px rgba(99,102,241,0.35)',
                    transition: 'all 0.25s cubic-bezier(0.4,0,0.2,1)',
                    '&:hover': { boxShadow: '0 12px 35px rgba(99,102,241,0.45)', transform: 'scale(1.05)' },
                }}>
                {open ? <CloseIcon /> : <AddIcon />}
            </Fab>
        </Box>
    );
}
